import Axios from 'axios'
import store from '../store'

const locker =  {
  getFreeroomUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_FREEROOM
  },
  getClientIdFreeroom () {
    return store.getters['Client/clientIdFreeroom']
  },
  getAvailableRooms (clientId) {
    const client = clientId ? clientId : this.getClientIdFreeroom()
    return Axios.get(`${this.getFreeroomUrl()}/api/internal/clients/${client}/rooms`)
  }
}

export default locker
